export const AI_AGENT_NAME = "Clara";
